import './App.css';
import AppRouter from './components/AppRouter';





function App() {
  return (
    <div >

      <AppRouter/>
    </div>
  );
}

export default App;
